import React, { FC, memo, useMemo } from 'react'
import { ExternalLogo } from '@ucheba/ui/components/ExternalLogo/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IEventsId } from '@ucheba/store/events/id/types'
import { EColorBgText } from '@ucheba/utils/helpers/styles/variables'

const EventsInstitution: FC<IEventsId['institution'] & IEventsId['branding']> = (
  props
) => {
  const { logo, name, id, location, headerBackgroundColor: themeColor } = props

  const href = useMemo(() => `/uz/${id}`, [id])
  const regionName = location?.name

  return (
    <>
      {logo && (
        <>
          <ExternalLogo logo={logo} href={href} maxWidth='100px' maxHeight='86px' />

          <Spacing spacing='small' />
        </>
      )}

      {name && (
        <Heading
          h4={name}
          href={href}
          color={themeColor ? EColorBgText[themeColor] : 'blue'}
          spacing='null'
        />
      )}

      {regionName && <Heading h4={regionName} color='gray40' spacing='null' />}
    </>
  )
}

export default memo(EventsInstitution)
